import { useState } from 'react';
import {
	PaginationOrderHow,
	useLazyWorkplaceInsuranceBatchsQuery,
	WorkplaceInsuranceBatchsWhereInput,
} from '../../../graphql/graphql';

export default function useInsuranceReturnedBatches() {
	const [getInsuranceBatchsQuery, { data, isLoading }] =
		useLazyWorkplaceInsuranceBatchsQuery();
	const [page, setPage] = useState(1);

	const getFlatInsuranceReturnedBatches = (
		filter: WorkplaceInsuranceBatchsWhereInput,
	) => {
		getInsuranceBatchsQuery({
			where: filter,
			pagination: {
				take: 20,
				skip: (page - 1) * 20,
				order: {
					key: 'insurance_batch.created_at',
					how: PaginationOrderHow.Desc,
				},
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatInsuranceReturnedBatches,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
